import { createAction } from '@reduxjs/toolkit'
import { TakeOffCalculation, TakeOffItem } from '../models/TakeOff'

export const showItemList = createAction<boolean>('takeOff/showItemList')
export const setItemList = createAction<{ items: TakeOffItem[] }>(
  'takeOff/setItemList',
)

export const selectAreas = createAction<{ areasIds: string[] }>(
  'takeOff/selectAreas',
)
export const deselectAreas = createAction<{ areasIds: string[] }>(
  'takeOff/deselectAreas',
)

export const setIsTakeOffCalculationInProgress = createAction<boolean>(
  'takeOff/setIsTakeOffCalculationInProgress',
)
export const updateTakeOffCalculation = createAction<TakeOffCalculation | null>(
  'takeOff/updateTakeOffCalculation',
)
